import { createAction, props } from '@ngrx/store';
import { ThreadCreationModel, ThreadModel } from '../../models';

const LoadAllThreadsAction = createAction('[Thread/API] load all threads');

const AllThreadsLoadedAction = createAction('[Thread/API] all threads loaded', props<{ threads: ThreadModel[] }>());

/** Create actions */
const CreateThreadAction = createAction(
  '[Thread/API] create thread',
  props<{ thread: ThreadCreationModel; operationId: string }>(),
);

const ThreadCreatedAction = createAction('[Thread/API] thread created successfully', props<{ thread: ThreadModel }>());

const CreateThreadFailedAction = createAction(
  '[Thread/API] failed to create thread',
  props<{ thread: ThreadCreationModel }>(),
);

const ThreadsUpdatedAction = createAction('[Thread/API] threads updated', props<{ updatedThreads: ThreadModel[] }>());

const UpdateThreadsFailedAction = createAction(
  '[Thread/API] failed to update thread',
  props<{ threadsBeforeUpdate: ThreadModel[] }>(),
);

const DeleteThreadAction = createAction(
  '[Thread/API] delete single thread',
  props<{ threadId: string; operationId: string }>(),
);

const UpdateThreadBodyAction = createAction(
  '[Thread/API] update thread body',
  props<{
    threadId: string;
    newBody: string;
    mentionedEmails: string[];
    extraParams?;
    operationId: string;
  }>(),
);

const ResolveThreadAction = createAction(
  '[Thread/API] resolve thread',
  props<{ threadId: string; operationId: string }>(),
);

const ActivateThreadAction = createAction(
  '[Thread/API] activate thread',
  props<{ threadId: string; operationId: string }>(),
);

const BulkResolveThreadsAction = createAction(
  '[Thread/API] bulk resolve threads',
  props<{ operationId: string; threadIdsToResolve: string[] }>(),
);

const BulkActivateThreadsAction = createAction(
  '[Thread/API] bulk activate threads',
  props<{ operationId: string; threadIdsToActivate: string[] }>(),
);

const BulkDeleteThreadsAction = createAction(
  '[Thread/API] bulk delete threads',
  props<{ operationId: string; threadIdsToDelete: string[] }>(),
);

const ThreadsDeletedAction = createAction('[Thread/API] threads deleted', props<{ deletedThreads: ThreadModel[] }>());

const DeleteThreadsFailedAction = createAction(
  '[Thread/API] failed to delete thread',
  props<{ deletedThreads: ThreadModel[] }>(),
);

export const ThreadAction = {
  LoadAll: LoadAllThreadsAction,
  AllLoaded: AllThreadsLoadedAction,
  Create: CreateThreadAction,
  Created: ThreadCreatedAction,
  CreateFailed: CreateThreadFailedAction,
  Updated: ThreadsUpdatedAction,
  UpdateFailed: UpdateThreadsFailedAction,
  UpdateBody: UpdateThreadBodyAction,
  ResolveSingle: ResolveThreadAction,
  ActivateSingle: ActivateThreadAction,
  ResolveBatch: BulkResolveThreadsAction,
  ActivateBatch: BulkActivateThreadsAction,
  DeleteBatch: BulkDeleteThreadsAction,
  DeleteSingle: DeleteThreadAction,
  Deleted: ThreadsDeletedAction,
  DeleteFailed: DeleteThreadsFailedAction,
};
